import classNames from 'classnames';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

export const ExampleImageCellWithoutStyle = ({
  backgroundImageUrl,
  promptText,
  onSelectImage,
  index,
  classes,
  MultiLineEllipsisText,
}) => {
  // when press Enter key, trigger the click event
  const onKeyDown = useCallback((event) => {
    if (event.key === 'Enter') {
      onSelectImage(promptText, index);
    }
  }, [index, onSelectImage, promptText]);

  const onClick = useCallback(() => {
    onSelectImage(promptText, index);
  }, [index, onSelectImage, promptText]);

  return (
    <div
      className={classNames('example-image-list-cell', classes.exampleImageCell)}
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-label={promptText}
      onKeyDown={onKeyDown}
    >
      <img src={backgroundImageUrl} alt={`Example ${index}`} />
      <div className="example-image-list-cell-overlay">
        <div className="overlay-gradient" />
        <div className="overlay-solid" />
        <MultiLineEllipsisText
          className="example-prompt-template"
          text={promptText}
        />
      </div>
    </div>
  );
};

ExampleImageCellWithoutStyle.propTypes = {
  backgroundImageUrl: PropTypes.string.isRequired,
  promptText: PropTypes.string.isRequired,
  onSelectImage: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  classes: PropTypes.shape({
    exampleImageCell: PropTypes.string,
  }),
};

ExampleImageCellWithoutStyle.defaultProps = {
  classes: {},
};
